import React from "react";

function DisputeResolution() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Dispute Resolution</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              As mentioned above corporate clients make up a major proportion of our client portfolio.  Such clients get into transactions of their own which will unfortunately lead to inevitable disputes.
              </p>
              <p>
              Disputes are no longer resolved solely by going to court.  Disputes can now be resolved through various means such as negotiation, settlement, arbitration and mediation.
              </p>
              <p>
              Adapting to such changing times in terms of dispute resolution is essential for survival in this area of practice.  Dispute resolution also still involves high levels of correspondence and preparing and issuing or defending court proceedings.
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default DisputeResolution;
